// Independent of A-F CCMR — do not import Ccmr/* or write ccmrIndicators*.
import { combineEpics, ofType } from 'redux-observable';
import { map, switchMap, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { asyncError, asyncFinish } from '../../common/+store/index';
import { GET_OUTCOMES_BONUS, UPLOAD_OUTCOMES_BONUS_FILE } from './outcomesBonus.actions';
import { getOutcomesBonus, uploadOutcomesBonusFile } from './outcomesBonus.api';
import { commonApiCallFragment } from '../../common/+store/utils/utils.api';

const getOutcomesBonusEpic = (action$) =>
  action$.pipe(
    ofType(GET_OUTCOMES_BONUS),
    switchMap((action) =>
      from(getOutcomesBonus(action.gradYear)).pipe(commonApiCallFragment(action$, action, 'Get Outcomes Bonus'))
    ),
    switchMap((result) => {
      if (result.success) {
        return of(
          asyncFinish(result.action.type, {
            outcomesBonus: result.response,
          })
        );
      }
      if (result.actions) return of(...result.actions);
      return of(result.action);
    })
  );

const uploadOutcomesBonusFileEpic = (action$) =>
  action$.pipe(
    ofType(UPLOAD_OUTCOMES_BONUS_FILE),
    switchMap((action) =>
      from(uploadOutcomesBonusFile(action.profile, action.file, action.gradYear)).pipe(
        map((result) => ({ action, success: true, result })),
        catchError((error) =>
          of({
            success: false,
            action,
            // Surface the api's clear message (e.g. wrong file type) to the toast.
            error: (error && error.message) || 'Could not upload the CCMR Outcomes Bonus file.',
            rawError: error,
          })
        )
      )
    ),
    switchMap((results) => {
      if (results.success) {
        // Refresh the node in place (no asyncStart -> no full-page spinner) so the
        // recomputed funding totals appear, and signal success for the toast. The
        // follow-on grad year comes from the upload result, since the action carried none.
        return of(asyncFinish(results.action.type, { result: results.result }), {
          type: GET_OUTCOMES_BONUS,
          gradYear: results.result.gradYear,
        });
      }
      return of(asyncError(results.action.type, results.error, results.rawError));
    })
  );

const epics = combineEpics(getOutcomesBonusEpic, uploadOutcomesBonusFileEpic);
export default epics;
